import { Component, OnInit } from '@angular/core';
import { StripeService } from '../services/stripe.service';
import { UserdataService } from '../services/userdata.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.css']
})
export class MyaccountComponent implements OnInit {

	location = 'myaccount';
  userData: any;
  userSecureData: any;

  constructor(
    private StripeService: StripeService,
    private userDataService: UserdataService,
    private authService: AuthService,
  ) { }

  ngOnInit() {

    this.authService.getAuthState()
      .subscribe((user) => {

        console.log('user:', user);
        

        // if we have a user, show avatar and say hi
        if(user){

          this.userDataService.getData()
            .subscribe(data => {
              this.userData = data;
              console.log('userData:', this.userData);
            })

          this.userDataService.getSecureData()
            .subscribe(data => {
              this.userSecureData = data;
              console.log('Secure userData:', this.userSecureData)
            })
        }

      });
          
  }

 async openBillingUrl() {

    let res = await this.StripeService.getBillingUrl(this.userData.stripeInfo.stripeId);
    if(res.errorMessage){
      // open new tab with billing url
      alert("Dang, something went wrong")
      console.log("err getting billing URL:", res.errorMessage)
    } else {
      // no error
      console.log('stripe res:', res);
      
      window.open(res.url, '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/myaccount/myaccount.component.ts